import * as React from 'react';
import {
	Create,
	CreateProps,
	NumberInput,
	SimpleForm,
	TextInput,
	minValue,
	maxValue,
	required,
	SelectInput
} from 'react-admin';
import { ELanguage } from "../enums";

export const OrganizationNotificationCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<TextInput step={1} source="title" label="TITLE" validate={[required()]}/>
				<TextInput step={1} source="body" label="BODY" validate={[required()]}/>
				<NumberInput step={1} source="dayInMonth" label="DAY_IN_MONTH" validate={[minValue(1), maxValue(31), required()]}/>
				<SelectInput step={1} source="language" label="LANGUAGE" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(ELanguage).map(key => ({
					id: ELanguage[key],
					name: ELanguage[key]
				}))]}/>
			</SimpleForm>
		</Create>
	);
};
